export default function getSource() {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get("source");
}
